import { Component, OnInit } from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import { IBlockRepository } from "../../../domain/blocks/i-block.repository";
import { Router } from "@angular/router";
import moment from "moment";
import { ShowRepository } from "../../../domain/show-repository";
import { Show } from "../../../domain/show";
import { EditBlockViewModel } from "../edit-block-header/edit-block.view-model";
import { CopyShowsViewModel } from "../../../services/show/copy-shows.view-model";
import { UI } from "../../../services/ui.service";

@Component({
  selector: "evrideo-block-show-modal",
  templateUrl: "./create-block-modal.component.html",
  styleUrls: ["./create-block-modal.component.scss"],
})
export class CreateBlockModalComponent implements OnInit {
  public name: string;
  private _copyFromData: {
    sourceChannelId: number;
    fromTime: moment.Moment;
    toTime: moment.Moment;
    isStack: boolean;
  };
  constructor(
    private _ngxSmartModalService: NgxSmartModalService,
    private _blockRepository: IBlockRepository,
    private _router: Router,
    private _showsRepository: ShowRepository,
    private _ui: UI,
  ) {}

  ngOnInit(): void {
    console.log("CreateBlockModalComponent->ngOnInit");
    this._ngxSmartModalService
      .getModal("createBlockModal")
      .onOpen.subscribe(() => {
        this.name = "";
      });
    this._ngxSmartModalService
      .getModal("createBlockModal")
      .onDataAdded.subscribe((data: any) => {
        this._copyFromData = data;
      });
  }

  cancel() {
    this._ngxSmartModalService.getModal("createBlockModal").close();
  }

  async create() {
    const newBlock = await this._blockRepository.create(this.name);
    if (this._copyFromData) {
      const foundShows = await this._showsRepository.getByDates(
        this._copyFromData.sourceChannelId,
        this._copyFromData.fromTime,
        this._copyFromData.toTime,
        true,
        null,
        true,
      );

      const relevantShows =
        EditBlockViewModel.getRelevantBlockShows(foundShows);
      if (relevantShows.length > 0) {
        await CopyShowsViewModel.showConfirmSecondaryEventSignalSettingsPopup(
          this._ui,
          this._showsRepository,
          newBlock,
          true,
          foundShows[0],
          foundShows[foundShows.length - 1],
          moment(),
        );
      }

      newBlock.duration =
        EditBlockViewModel.calculateShowsDuration(relevantShows);
      if (relevantShows.length > 0) {
        newBlock.packshotUrl = relevantShows[0].thumbnailUrl;
      }
      newBlock.showsCount = relevantShows.length;
      newBlock.isBlockStack = this._copyFromData.isStack;
      this._blockRepository.updated.next(newBlock);
    }

    this._ngxSmartModalService.getModal("createBlockModal").close();

    if (!this._copyFromData) {
      await this._router.navigate(["/blocks/edit/", newBlock.id]);
    }
  }

  async onKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      await this.create();
    }
  }
}
